//
//
//      多处调用
//
//
import {
    mapState,
    mapMutations
} from "vuex";
export default {
    computed: {
        ...mapState('imgeditor', [
            'isCrop', 'goSel'
        ])
    },
    data() {
        return {
            tesTex: "AAz1", //不要用下划线命名，会被 vue 转掉
            tW: 820, //如果这两个值不固定，计算起来会复杂
            tH: 440,
            bodyCon: null,
            theBody: null,
            theCanvas: null,
            theEditor: null,
            inpFileLoad: null,
            fileLoad: null, //一键复原用的，把这张图重新加载一遍
            menuLast: null,
            btnLast: null,
            StaTool: {
                text: 1,
                shape: 1,
                crop: 1,
                rotate: 1,
                flipX: 1,
                flipY: 1,
                select: 1,
                del: 1,
                reset: 1,
                redo: 1,
                undo: 1
            },
            UrlTool: {
                text: 'wenzi',
                shape: 'quyuxinzhuang',
                crop: 'jiancai',
                rotate: 'xuanzhuang',
                flipX: 'jinxiang',
                flipY: 'zxjinxiang',
                select: 'kuangxuan',
                del: 'shanchu',
                reset: 'chongzuo',
                redo: 'huifu',
                undo: 'chexiao'
            }
        };
    },
    watch: {
        goSel() {
            this.chanBtn('select');
        }
    },
    methods: {
        ...mapMutations('imgeditor', [
            'showCrop', 'modSel'
        ]),
        FlipX() {
            var imageEditor = window.imageEditor;
            if (window.aoTp == 'group') {
                imageEditor.discardSelection();
            }
            if (window.aoTp == 'cropzone') {
                this.ModSel();
            }
            imageEditor.flipX();
            if (this.StaTool.flipX == 3) {
                this.StaTool.flipX = 1;
            } else {
                this.StaTool.flipX = 3
            }
        },
        FlipY() {
            var imageEditor = window.imageEditor;
            if (window.aoTp == 'group') {
                imageEditor.discardSelection();
            }
            if (window.aoTp == 'cropzone') {
                this.ModSel();
            }
            imageEditor.flipY();
            if (this.StaTool.flipY == 3) {
                this.StaTool.flipY = 1;
            } else {
                this.StaTool.flipY = 3
            }
        },
        Delete() { //删除选中的物体，不管 aoId 也没事
            window.imageEditor.removeActiveObject();
            window.aoTp = '';
        },
        Reset() {
            var _this = this;
            if (_this.fileLoad) {
                window.imageEditor
                    .loadImageFromFile(_this.fileLoad)
                    .then(function () {
                        _this.ReUI(); //要复原界面
                    })
                    .catch(function () {}); //仅为了防止报红
            }
        },
        ReUI() {
            this.StaTool.flipX = 1;
            this.StaTool.flipY = 1;
            window.$('.menu-rotate').find('input').val(0);
        },
        Undo() {
            window.imageEditor
                .undo()
                .then(function () {
                    //此时 mod 已经是 NORMAL，getCropzoneRect null 但框还在
                    //全清是可以的，异步完，才可以干掉框
                    if (window.hasCrop) {
                        window.imageEditor.killCrop();
                    }
                })
                .catch(function () {});
        },
        Redo() {
            window.imageEditor
                .redo()
                .then(function () {})
                .catch(function () {});
        },
        StaText() {
            //比如 select，不会还原 menu，镜像是都不还原
            window.$('.menu-edit').hide();
            this.chanBtn('text');
            this.chanMenu('text');
            this.showCrop(false);
            window.imageEditor.startDrawingMode('TEXT');
        },
        StaShape() {
            this.chanBtn('shape');
            this.chanMenu('shape');
            this.showCrop(false);
            this.ModShape();
        },
        StaCrop() {
            this.chanBtn('crop');
            this.chanMenu('crop');
            window.imageEditor.startDrawingMode('CROPPER');
        },
        StaRoate() {
            this.chanBtn('rotate');
            this.chanMenu('rotate');
            this.showCrop(false);
            window.imageEditor.stopDrawingMode();
        },
        ModSel() {
            this.chanBtn('select');
            this.showCrop(false); //防止因为没有触发 isCrop 改变
            window.imageEditor.stopDrawingMode();
        },
        ApplyCrop() {
            var imageEditor = window.imageEditor;
            var rect = imageEditor.getCropzoneRect();
            imageEditor.crop(rect);
            this.ModSel(); //执行完一定要结束掉
        },
        ModShape() {
            var imageEditor = window.imageEditor;
            imageEditor.stopDrawingMode();
            var shapeOptions = {
                stroke: null,
                fill: window.colPick.getcol('shape')
            };
            imageEditor.setDrawingShape('rect', shapeOptions);
            imageEditor.startDrawingMode('SHAPE');
        },
        chanBtn(type) {
            var btn = this.btnLast;
            if (btn != null) {
                this.StaTool[btn] = 1;
            }
            this.StaTool[type] = 3;
            this.btnLast = type;
        },
        chanMenu(menu) {
            function jQ(str) {
                return window.$(str);
            }
            var _this = this;
            if (_this.menuLast == null) {
                jQ('.picsize').find('.horizon').show();
            } else {
                jQ('.menu-' + _this.menuLast).hide();
            }
            _this.menuLast = menu;
            jQ('.menu-' + menu).show();
        },
        ShowImgSize(fileLoad) {
            var img = new Image();
            img.src = this.getObjectURL(fileLoad);
            img.onload = function () {
                var inp = window.$('.picsize').find('.twin').find('p');
                inp.first().html('高：' + img.height + 'px');
                inp.last().html('宽：' + img.width + 'px');
                img = null;
            }
        },
        getObjectURL(file) {
            var url = null;
            if (window.createObjcectURL != undefined) {
                url = window.createOjcectURL(file);
            } else if (window.URL != undefined) {
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL != undefined) {
                url = window.webkitURL.createObjectURL(file);
            }
            return url;
        }
    }
};